import request from '@/utils/request';
import { APP_ID } from '@/constants';

export function getLogin(username, password, isQrLogin, appid, agentid, code) {
  const formData = new FormData();
  if (isQrLogin) {
    formData.append('grant_type', 'scan');
    formData.append('appid', appid);
    formData.append('agent_id', agentid);
    formData.append('code', code);
  } else {
    formData.append('username', username);
    formData.append('password', password);
    formData.append('grant_type', 'password');
  }

  return request('/oauth/token', {
    method: 'POST',
    data: formData,
  });
}
export function getUser(userId) {
  return request(`/users/${userId}`, {
    method: 'GET',
    params: {
      appId: APP_ID.loyalty,
    },
  });
}
